import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a0628fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"display":"none"} }

import {computed, ref} from "vue";
import {ImgFieldType} from "@/components/business/crud/interface/FieldType";
import config from "@/config";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImgTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const images = computed(() => {
  const data = props.data[props.propName];
  if (data instanceof Array) {
    return data.filter(i => i).map(i => i.startsWith('/') ? config.uploadPath + i : i);
  }
  if (typeof data === 'string' && data) {
    return [data.startsWith('/') ? config.uploadPath + data : data];
  }
  return [];
})

const visible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (images.value[0])
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "img",
          src: images.value[0],
          onClick: _cache[0] || (_cache[0] = () => visible.value = !visible.value)
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_image_preview_group, {
        preview: { visible: visible.value, onVisibleChange: vis => (visible.value = vis) }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value, (image, index) => {
            return (_openBlock(), _createBlock(_component_a_image, {
              width: 50,
              src: image,
              key: index
            }, null, 8, ["src"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["preview"])
    ])
  ]))
}
}

})